module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/step2-3-7bf448570703374ab19fa1bf8cf370f4.gif";